<template>
	<div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9" style="max-width: 2000px;">
			<div class="d-flex mb-3 mb-xl-0 flex-column flex-xl-row" >
        <div class="mr-3 flex-grow-1" style="min-width: 1px;">
          <!-- Datos del cliente -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header bg-transparent">
                <div class="d-flex flex-column flex-2xl-row align-items-start justify-content-2xl-between align-items-2xl-center">
                  <div class="flex-grow-1 mb-3 mb-2xl-0">
                    <div class="d-flex flex-column flex-2xl-row align-items-2xl-center">
                      <span class="m-0 h3">{{delivery.CardName}}
                        <span class="text-muted m-0 h4">{{delivery.CardCode}}</span>
                      </span>
                    </div>
                    <h4 class="text-muted m-0 d-flex align-items-center font-weight-normal">
                      <span>Entrega 
                        <span style="letter-spacing: 0.5px;">
                          #{{$route.params.DocNum}}
                        </span>
                      </span>
                      <badge v-if="delivery.DocumentStatus === 'bost_Open'" type="primary" class="ml-2">Abierta</badge>
                      <badge v-else-if="delivery.CancelStatus === 'csYes'" type="danger" class="ml-2">Cancelada</badge>
                      <badge v-else-if="delivery.DocumentStatus === 'bost_Close'" type="light" class="ml-2">Cerrada</badge>
                    </h4>
                  </div>
                  <div class="d-flex flex-wrap flex-2xl-row ml-2xl-4 align-items-start justify-content-center">
                    <base-button 
                      @click="deliveryPdf();" 
                      icon="fas fa-file-pdf"
                      size="sm"
                      class="mb-1"
                      :disabled="!delivery || downloadingDelivery">
                      Entrega PDF
                    </base-button>
    
                    <base-button 
                      @click="dcpPdf();" 
                      icon="fas fa-file-pdf"
                      size="sm"
                      :disabled="!delivery || downloadingDcp">
                      DCP PDF
                    </base-button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex flex-column flex-2xl-row">
                  <div class="d-flex my-1">
                    <h5 class="m-0">RFC</h5>
                    <p class="text-xs pl-2 m-0"><b>{{delivery.FederalTaxID}}</b></p>
                  </div>
                  <div class="d-flex my-1 ml-2xl-4" v-if="customer.U_TS_RegFiscal && regimenes">
                    <h5 class="m-0">Régimen Fiscal</h5>
                    <p class="text-xs pl-2 m-0"><b>{{regimenes.find(x => x.Code === customer.U_TS_RegFiscal).Name}}</b></p>
                  </div>	
                  <div class="d-flex my-1 ml-2xl-4">
                    <h5 class="m-0">Uso CFDI</h5>
                    <p class="text-xs pl-2 m-0"><b>{{ delivery.U_TS_UsoCFDI40 }}</b></p>
                  </div>
                </div>
              </div>
              </div>
              <div v-else style="height: 700px; padding-top: 300px;">
                <base-loader></base-loader>
              </div>
          </div>
          <!-- Detalles de entrega -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header py-3">
              <h6 class="heading-small text-muted m-0 p-0">Detalles de Entrega</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
              <div class="row">
                <div class="col-md-6 col-2xl-4 d-flex my-1">
                  <h5 class="m-0 flex-shrink-0">Almacén</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{delivery.DocumentLines[0].WarehouseCode}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1">
                  <h5 class="m-0 flex-shrink-0">C. P. de Almacén</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{zipCode}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1" v-if="delivery.SalesPersonCode && salesPersonOptions">
                  <h5 class="m-0 flex-shrink-0">Vendedor</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{salesPersonOptions.find(x => x.SalesEmployeeCode === delivery.SalesPersonCode).SalesEmployeeName}}</b></p>
                </div>				
                <div class="col-md-6 col-2xl-4 d-flex my-1" >
                  <h5 class="m-0 flex-shrink-0">Contacto</h5>
                  <p class="text-xs pl-2 m-0 text-truncate" v-if="delivery.ContactPersonCode && customer">
                    <b>{{customer.ContactEmployees.find(x => x.InternalCode === delivery.ContactPersonCode).Name}}</b>
                  </p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1">
                  <h5 class="m-0 flex-shrink-0">Moneda</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{delivery.DocCurrency}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1">
                  <h5 class="m-0 flex-shrink-0">Fecha contable</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{delivery.DocDate}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1">
                  <h5 class="m-0 flex-shrink-0">Fecha de entrega</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{delivery.DocDueDate}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0 flex-shrink-0">Periodicidad</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{globalInformation.periodicity}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0 flex-shrink-0">Meses</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{globalInformation.months}}</b></p>
                </div>
                <div class="col-md-6 col-2xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0 flex-shrink-0">Año</h5>
                  <p class="text-xs pl-2 m-0 text-truncate"><b>{{globalInformation.year}}</b></p>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- Tabla de artículos -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header py-3 border-0 d-flex justify-content-between">
              <h6 class="heading-small text-muted m-0 p-0">Artículos</h6>
              <base-button v-if="!showItemsForm" @click="loadItemsForm()" size="sm" icon="fa fa-plus">
                Agregar Artículos
              </base-button>
            </div>

            <div v-if="showItemsForm" class="px-4 py-3 d-flex border-top">
              <div class="flex-grow-1 row">
                <div class="col-5">
                  <multiselect
                  v-model="selOpenDelivery"
                  :options="openDeliveries || []"
                  :loading="!openDeliveries"
                  placeholder="Entrega"
                  :custom-label="x => `Entrega #${x.DocNum}`"
                  class="small-multiselect"
                  :show-labels="false"
                  :allow-empty="false"
                  @select="onSelectOpenDelivery"
                  />
                </div>
                <div class="col-7">
                  <multiselect
                    v-model="selOpenItem"
                    :options="openItems || []"
                    :loading="selOpenDelivery && !openItems"
                    placeholder="Seleccionar Artículos"
                    class="small-multiselect"
                    :custom-label="(x) => `${x.ItemCode} - ${x['DeliveryNotes/DocumentLines'].ItemDescription}`"
                    :show-labels="false"
                    :disabled="!selOpenDelivery"
                    :multiple="true"
                    :group-select="true"
                    group-values="items" 
                    group-label="all"
                    :close-on-select="false"
                    track-by="ItemCode"
                  >
                    <template #selection="{ values, search, isOpen }">
                      <span v-if="values.length" v-show="!isOpen" class="text-xs">
                        {{ values.length }}/{{ openItems[0].items.length }} Artículos seleccionados
                      </span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="flex-shrink-0 ml-4">
                <base-button @click="onCancelItemsForm" size="sm" type="muted">
                  Cancelar
                </base-button>
                <base-button @click="addLines" size="sm" type="success" icon="fa fa-check">
                  Agregar
                </base-button>
              </div>
            </div>

              <div v-if="docLines" class="table-responsive custom-table">
                <base-table thead-classes="thead-light" :data="docLines">
                  <template #columns>
                    <th></th>
                    <th>#</th>
                    <th width="40%" class="">Artículo</th>
                    <th width="10%" class="text-center">Pedimento</th>
                    <th 
                      width="10%" 
                      class="text-center" 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'">
                      Fracc. Arancelaria
                    </th>
                    <th width="10%" class="text-right">Rollos</th>
                    <th width="10%" class="text-right">Cantidad</th>
                    <th width="10%" >U. medida</th>
                    <th 
                      width="10%" 
                      class="text-center" 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'">
                      Cant. Aduana
                    </th>
                    <th 
                      width="10%" 
                      class="text-center" 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'">
                      Valor U. Dlls
                    </th>
                    <th 
                      width="10%" 
                      class="text-center" 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'">
                      Unidad Aduana
                    </th>
                    <th width="10%" class="text-right">Precio Unitario</th>
                    <th width="10%" class="text-right">Total</th>
                  </template>
                  <template #default="{ row, index }">
                    <td class="text-center">
                      <base-checkbox 
                        v-if="!row.addedLine"
                        v-model="row.checked" 
                        :disabled="row.disabled" 
                        @input="calculateTotals"
                        class="ml-2"
                      />
                      <base-button
                        v-else
                        @click="removeLine(index)"
                        icon="fa fa-trash"
                        size="sm"
                        type="danger"
                        outline
                      >
                      </base-button>
                    </td>
                    <td
                      scope="row"
                      class="text-xs"
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                      {{ row["DeliveryNotes/DocumentLines"].LineNum + 1 }}
                    </td>
                    <td
                      scope="row" 
                      width="40%" 
                      class="text-xs"
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                      <div class="mb-1">
                        <span>{{ row["DeliveryNotes/DocumentLines"].ItemDescription }}</span>
                        <br>
                        <b>{{ row["DeliveryNotes/DocumentLines"].ItemCode }} </b>
                      </div>
                      <div v-if="row['DeliveryNotes/DocumentLines'].U_SubCode">
                        <span class="text-primary">{{ row["DeliveryNotes/DocumentLines"].U_SubDescription }}</span> 
                        <br>
                        <b class="text-primary">{{ row["DeliveryNotes/DocumentLines"].U_SubCode }} </b>
                      </div>
                    </td>
                    <td 
                      scope="row"
                      width="10%" 
                      class="text-center text-xs"
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                      <multiselect
                        v-append-to-body
                        v-if="row.BatchNum"
                        v-model="row.BatchNum"
                        :options="row.BatchNums || []"
                        placeholder="Num. Pedimento"
                        :show-labels="false"
                        style="width: 170px;"
                        class="small-multiselect"
                        :disabled="row.disabled"
                        :allow-empty="false"
                      >
                      </multiselect>
                      
                      <base-input
                        v-else-if="row.Items.U_Import === 'Y' && delivery.DocumentStatus === 'bost_Open'"
                        v-model="row.U_PedimentNum"
                        inputClasses="input-group-alternative form-control-sm text-xs"
                        placeholder="Num. Pedimento" 
                        class="m-0" 
                        style="width: 170px;"
                        :disabled="row.disabled"
                      >
                      </base-input>
                      <span v-else>-</span>
                    </td>
                    <td 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'"
                      scope="row" 
                      width="10%" 
                      class="text-right text-xs"
                      :class="row.disabled ? 'opacity-5' : '' " 
                    >
                      <multiselect
                        v-append-to-body
                        v-if="delivery.DocumentStatus === 'bost_Open'"
                        v-model="row['DeliveryNotes/DocumentLines'].FraccionArancelaria"
                        :options="fraccArancelarias ? fraccArancelarias : []"
                        placeholder="Fracc Arancelaria"
                        style="width: 320px;"
                        :loading="!fraccArancelarias"
                        :custom-label="customFraccLabel"
                        track-by="Name"
                        :show-labels="false"
                        class="small-multiselect"  
                        :disabled="row.disabled"
                      >
                      </multiselect>
                    </td>
                    <td scope="row" width="10%" class="text-right text-xs" :class="row.disabled ? 'opacity-5' : '' ">
                      {{ row["DeliveryNotes/DocumentLines"].U_Rolls }}
                    </td>
                    <td scope="row" width="10%" class="text-right text-xs" :class="row.disabled ? 'opacity-5' : '' ">
                      <span v-if="delivery.DocumentStatus === 'bost_Close'">
                        {{ row["DeliveryNotes/DocumentLines"].Quantity }}
                      </span>
                      <base-input
                        v-else
                        v-model="row.newQuantity"
                        inputClasses="input-group-alternative form-control-sm text-xs"
                        class="m-0"
                        type="number"
                        placeholder="Cant."
                        min="1"
                        @input="calculateTotals"
                        :max="row.remainingOpenQuantity"
                        :disabled="row.disabled"
                      >
                      </base-input>
                    </td>
                    <td scope="row" width="10%" class="text-xs" :class="row.disabled ? 'opacity-5' : '' ">
                      {{ row["DeliveryNotes/DocumentLines"].MeasureUnit}}
                    </td>
                    <td 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'"
                      scope="row" 
                      width="10%" 
                      class="text-right text-xs"
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                      <base-input
                        v-model="row['DeliveryNotes/DocumentLines'].CantAd"
                        inputClasses="input-group-alternative form-control-sm text-xs"
                        class="m-0" 
                        style="width: 120px;"
                        type="number"
                        placeholder="Cant. Aduana" 
                        required
                        :disabled="row.disabled"
                      />
                    </td>
                    <td 
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'"
                      scope="row" 
                      width="10%" 
                      class="text-right text-xs"
                      :class="row.disabled ? 'opacity-5' : '' " 
                    >
                      {{ delivery.DocumentLines[index].RowTotalFC/row["DeliveryNotes/DocumentLines"].CantAd > 0 ? '$ '+(delivery.DocumentLines[index].RowTotalFC/row["DeliveryNotes/DocumentLines"].CantAd).toFixed(6):null}}
                    </td>
                    <td
                      v-if="delivery.FederalTaxID === 'XEXX010101000' && invoiceType=='Comercio Exterior'"
                      scope="row" 
                      width="10%" 
                      class="text-right text-xs" 
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                      <multiselect
                        v-append-to-body
                        v-if="delivery.DocumentStatus === 'bost_Open'"
                        v-model="row['DeliveryNotes/DocumentLines'].UAduana"
                        :options="UAduanaOptions ? UAduanaOptions : []"
                        placeholder="Unidad Aduana"
                        :loading="!UAduanaOptions"
                        label="Description"
                        track-by="Value"
                        :show-labels="false"
                        style="width: 180px;"
                        class="small-multiselect"
                        :disabled="row.disabled"
                      >
                      </multiselect>
                    </td>
                    <td 
                      scope="row" 
                      width="10%" 
                      class="text-right text-xs"
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                      {{ currencyFormat(row["DeliveryNotes/DocumentLines"].UnitPrice, currency.iso) }}
                    </td>
                    <td 
                      scope="row" 
                      width="10%" 
                      class="text-right text-xs"
                      :class="row.disabled ? 'opacity-5' : '' "
                    >
                        {{ currencyFormat(calculateLineTotal(row), currency.iso) }}
                    </td>
                  </template>
                </base-table>
              </div>
              <div class="d-flex justify-content-end px-4 border-top py-2">
                <table class="text-right text-sm">
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
                    <td>
                      {{ currencyFormat(subtotal, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">IVA</h5></th>
                    <td>
                      {{ currencyFormat(iva, currency.iso) }}
                    </td>
                  </tr>
                  <tr v-if="delivery.DiscountPercent > 0">
                    <th class="pr-4"><h5 class="my-1">Descuento</h5></th>
                    <td>
                      {{ currencyFormat(discount, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Total</h5></th>
                    <td>
                      {{ currencyFormat(total, currency.iso) }}
                    </td>
                  </tr>
                </table>
              </div>
          </div>
          <!-- Datos Adicionales -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header py-3">
              <h6 class="heading-small text-muted m-0 p-0">Datos adicionales</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
                <div class="row">
                <div class="col-12 col-2xl-6 d-flex my-1">
                  <h5 class="m-0">Referencia</h5>
                  <p class="text-xs ml-2"><b>{{delivery.NumAtCard}}</b></p>
                </div>
                <div class="col-12 col-2xl-6 d-flex my-1">
                  <h5>Comentarios</h5>
                  <p class="text-xs ml-2"><b>{{delivery.Comments}}</b></p>
                </div>
                </div>
              </div>

                <div class="mb-3 border-top pt-3"
                  v-if="delivery.DocumentStatus === 'bost_Open'">
                  <div class="align-items-center">
                    <div v-if="needsReference && insufficientBalanceText" 
                      class="d-flex align-items-center bg-gradient-orange px-4 py-1 text-sm font-weight-bold text-white rounded mb-3" >
                      <i class="fas fa-exclamation-circle mr-3"></i>
                      <span>{{insufficientBalanceText}}</span>
                    </div> 
                    <div class="row">
                      <div class="col-6">
                        <h5 class="mb-1">Clave de autorización</h5>
                        <base-input
                          v-model="inputAuthKey"
                          inputClasses="input-group-alternative form-control-sm text-xs"
                          placeholder="Clave de autorización (Opcional)">
                        </base-input>
                      </div>
                      <div v-if="needsReference" class="col-6">
                        <h5 class="mb-1">Referencia Saldo a Favor *</h5>
                          <multiselect
                            v-model="importFileNum"
                            placeholder="Selecciona un folio"
                            :custom-label="(x) => x.Tipo + ' #' + x.Folio"
                            :options="balanceFavorOptions ? balanceFavorOptions : []"
                            track-by="Folio"
                            :show-labels="false"
                            @select="assignPayMethod"
                            class="small-multiselect"
                            >
                          <template slot="option" slot-scope="props">
                            <div>
                              <span><b>{{ props.option.Tipo }} #{{ props.option.Folio }} </b></span>
                              <span> - </span>
                              <span class="text-xs italic">Saldo a Favor: </span>
                              <b>
                                {{ currencyFormat(props.option["Saldo a Favor"], props.option.DocCurr) }}
                              </b>
                            </div>
                          </template>
                          </multiselect>
                        <span class="text-xs" v-if="!balanceFavorOptions">Solicita ayuda al departamento de cobranza</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class=" border-top pt-3" 
                  v-if="delivery.DocumentStatus === 'bost_Open' && customer && customer.FederalTaxID === 'XEXX010101000'">
                  <div class="row">

                  <div class="col-12 col-sm-4 col-md-12 col-lg-4 ">
                    <h5 class="mb-1">Tipo de Factura *</h5>
                    <div class="d-flex align-items-center">
                      <multiselect
                        v-model="invoiceType"
                        :options="['Comercio Exterior','Normal']"
                        placeholder="Tipo de Factura"
                        class="small-multiselect mb-3"
                        :show-labels="false">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-sm-8 col-md-12 col-lg-8" v-if="invoiceType=='Comercio Exterior'">
                    <h5 class="mb-1">Incoterm *</h5>
                    <div class="d-flex align-items-center">
                      <multiselect
                        v-model="selIncoterm"
                        :options="incoterms ? incoterms : []"
                        placeholder="Término de Comercio Internacional"
                        :loading="!incoterms"
                        :custom-label="x => `${x.Value} - ${x.Description}`"
                        track-by="Value"
                        class="small-multiselect"
                        :show-labels="false">
                      </multiselect>
                    </div>
                  </div>
                </div>

                </div>
            </div>
          </div>
        </div>
        <div class="custom-side-cards">
          <!-- Historial de documentos -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header py-3">
                <h6 class="heading-small text-muted m-0 p-0">Historial de Documentos</h6>
              </div>
              <document-history :docNum="$route.params.DocNum" table="ODLN" @reload="load()"/>
            </div>
            <div v-else class="py-6">
              <base-loader></base-loader>
            </div>
          </div> 
          <!-- Facturar a -->
          <div class="card shadow mb-3" v-if="customer">
              <div class="card-header py-3">
                <h6 class="heading-small text-muted m-0">Facturar a:</h6>
              </div>
              <div class="card-body py-2">
                <div class="d-flex mb-1 ">
                  <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                  <div class="text-xs m-0 font-weight-bold text-default">
                    <span>{{delivery.AddressExtension.BillToStreet}} </span>
                    <span>{{delivery.AddressExtension.BillToStreetNo}} </span>
                    <span>{{delivery.AddressExtension.BillToBlock}}</span>
                    <br>
                    <span>{{delivery.AddressExtension.BillToZipCode}} </span>
                    <span>{{delivery.AddressExtension.BillToCity}} </span>
                    <span>{{delivery.AddressExtension.BillToState}}</span>
                    <br>
                    <span>{{delivery.AddressExtension.BillToCountry}}</span>
                  </div>
                </div>
                <hr class="my-2">
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0 flex-shrink-0">Vía de Pago *</h5>
                  <span class="text-xs m-0 ml-2 " style="flex: 1; min-width: 0;">
                    <multiselect 
                      v-model="selPaymentMethod"
                      :options="paymentMethods || []"
                      placeholder="Seleccionar vía de pago"
                      class="small-multiselect"
                      label="description"
                      track-by="value"
                      :show-labels="false"
                      :allow-empty="false"
                    />
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Método de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{paymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Condiciones de Pago</h5>
                  <span v-if="paymentGroup" class="text-xs m-0 ml-2">
                    {{paymentGroup.PaymentTermsGroupName}}
                  </span>
                </div>
              </div>
          </div>
          <!-- Enviar a -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header py-3">
              <h6 class="heading-small text-muted m-0 p-0">Enviar a:</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex mb-1">
                <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                <div class="text-xs m-0 font-weight-bold text-default">
                  <span>{{delivery.AddressExtension.ShipToStreet}} </span>
                  <span>{{delivery.AddressExtension.ShipToStreetNo}} </span>
                  <span>{{delivery.AddressExtension.ShipToBlock}}</span>
                  <br>
                  <span>{{delivery.AddressExtension.ShipToZipCode}} </span>
                  <span>{{delivery.AddressExtension.ShipToCity}} </span>
                  <span>{{delivery.AddressExtension.ShipToState}}</span>
                  <br>
                  <span>{{delivery.AddressExtension.ShipToCountry}}</span>
                </div>
              </div>
              <hr class="my-2">
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Método de envío</h5>
                <span v-if="shippingMethod" class="text-xs m-0 ml-2">
                  {{shippingMethod.Description}}
                </span>
              </div>
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Pago flete</h5>
                <span v-if="freightPayment" class="text-xs m-0 ml-2">
                  {{freightPayment.Description}}
                </span>
              </div>
            </div>
          </div>
          <!-- Paquetes -->
          <div 
            v-if="
              customer && 
              delivery.DocumentStatus === 'bost_Open'
            "
            class="card shadow mb-3 pb-3" 
          >
            <div class="card-header d-flex justify-content-between align-items-center py-3">
              <h6 class="heading-small text-muted m-0 p-0">Guías</h6>
              <base-button 
                @click="modals.newTracking = true" 
                size="sm" 
                icon="fas fa-plus">
                Nueva guía
              </base-button>
            </div>
            <div class="card-body py-2"  style="max-height: 200px; overflow-y: auto;">
              <div>
                <div v-if="trackings && trackings.length > 0">
                  <div 
                    v-for="(t, index) in trackings" 
                    :key="index" 
                    class="d-flex justify-content-between align-items-center"
                    style="cursor: pointer;"
                    @click="openTracking(t, index)"
                  >
                  <div v-if="t.shipment" class="text-xs text-blue">
                    {{ t.shipment.carrier }}
                    {{ t.shipment.service }}
                    {{ t.packages.length }} Paquete(s)
                  </div>
                  <div v-else class="text-xs text-blue">
                    PAQUETEXPRESS
                    {{ t.isOcurre ? 'Ocurre' : 'Estándar' }}
                    {{ t.packages.length }} Paquete(s)
                  </div>
                  <div class="remove-button" @click.stop="removeTracking(index)">
                    <i class="fa fa-trash fa-xs"></i>          
                  </div>
                  </div>
                </div>
                <EmptySection v-else class="my-3" size="sm"/>
              </div>
            </div>
          </div>
          <!-- Factura anticipo -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header py-3">
              <h6 class="heading-small text-muted m-0 p-0">Factura anticipo a relacionar:</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex mb-1">
                <multiselect
                  v-if="facturasAnticipo.length > 0"
                  v-model="facturaAnticipoSelected"
                  :options="facturasAnticipo"
                  placeholder="Seleccionar factura anticipo"
                  :loading="!customer"
                  :custom-label="x => {
                    return `#${x.Folio} - Restante: ${currencyFormat(x.Restante, x.DocCur)}`
                  }"
                  track-by="Folio"
                  class="small-multiselect"
                  :show-labels="false">
                </multiselect>
                <span v-else class="text-xs">No hay facturas de anticipo para relacionar</span>
              </div>
              
              <div class="border-top mt-3 pt-3">
                <base-checkbox v-model="stamp" :disabled="stampDisabled">
                  Timbrar ante el SAT
                </base-checkbox>
              </div>
            </div>
          </div>

          <!-- Boton de Facturar -->
          <div v-if="customer">
            <div v-if="!creating && !reconciliando && delivery.DocumentStatus === 'bost_Open'"
              v-b-popover.hover.focus.bottom.html="popoverData">
              <base-button
                @click="askBefore();" 
                block
                icon="fas fa-check"
                :disabled="!validation.valid"
              >
              {{ 
                trackings && trackings.length ? 
                'Facturar y generar guía(s)' :
                'Facturar'
              }}
              </base-button>
            </div>
            <div v-if="creating || reconciliando" class="flex justify-items-center w-100">
              <base-loader text="Facturando. Espere un momento..."></base-loader>
            </div>
          </div>
        </div>
			</div>
		</div>

    <modal :show.sync="modals.newTracking" modal-classes="modal-dialog-centered modal-custom-size" @close="onCloseTracking">
      <NewTracking 
        v-if="modals.newTracking && delivery && customer && whseAddress"
        @add="onAddTracking"
        @edit="onEditTracking"
        @close="onCloseTracking"
        @openEditAddress="() => modals.editAddress = true"
        docType="delivery"
        :del="delivery"
        :customer="customer"
        :warehouse="whseAddress"
        :currentTracking="currentTracking"
        :currentTrackingIndex="currentTrackingIndex"
      />
      <base-loader v-else style="height: 80vh; min-height: 500px;" />
    </modal>

    <modal :show.sync="modals.editAddress" modal-classes="modal-dialog-centered modal-md" @close="modals.editAddress = false">
      <EditAddress
        v-if="modals.editAddress && delivery && customer"
        :shipToCode="delivery.ShipToCode"
        :customer="customer"
        @close="modals.editAddress = false"
        @success="load()"
      />
    </modal>

  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue';
import moment from "moment";
import { getAuth } from "firebase/auth";
import Multiselect from 'vue-multiselect'
import DocumentHistory from '@/components/DocumentHistory.vue';
import currency from '@/data/currency.json';
import appendToBody from '@/directives/appendToBody';
// import md5 from "md5-hash";
import paymentMethods from '@/data/paymentMethods.json';
import posthog from 'posthog-js';
import Formats from "@/mixins/Formats";
import NewTracking from './NewTracking.vue';
import EmptySection from "@/components/EmptySection.vue";
import EditAddress from './EditAddress.vue';

  export default {
    mixins: [Formats],
    components:{
      BaseLoader,
      Multiselect,
      DocumentHistory,
      NewTracking,
      EmptySection,
      EditAddress
    },
    directives: {
      appendToBody
    },
    data() {
      return {
        HANA_URL: process.env.VUE_APP_HANA_URL,
        user: null,
        docLines:[],
        delivery: null,
        customer: null,
        globalInformation: null,
        zipCode: null,
        paymentGroup: null,
        // needsAuthorization: false,
        // claveAutorizacion: null, 
        inputAuthKey: null,
        needsReference: false,
        importFileNum: null,
        modals:{
          complete: false,
          newTracking: false,
          editAddress: false
        },
        loadingImportFileNum: false,
        balanceFavorOptions: null,
        insufficientBalanceText: null, 
        regimenes: null,
        salesPersonOptions: null,
        facturama: null,
        creating: false,
        reconciliando: false,
        incoterms: null,
        selIncoterm: null,
        UAduanaOptions: null,
        UAduana: null,
        downloadingDelivery: false,
        downloadingDcp: false,
        currency: null,
        invoiceType: null,
        invoiceTypes: [
          {code: 'comercio_exterior', label: 'Comercio Exterior'},
          {code: 'normal', label: 'Normal'}
        ],
        fraccArancelarias:null,
        facturasAnticipo:[],
        facturaAnticipoSelected: null,
        paymentMethods: paymentMethods,
        selPaymentMethod: null,
        subtotal: 0,
        iva: 0,
        total: 0,
        discount: 0,
        openDeliveries: null,
        selOpenDelivery: null,
        openItems: null,
        selOpenItem: null,
        newItems: null,
        showItemsForm: false,
        stamp: false,
        stampDisabled: true,
        invoicingPermission: false,
        whseAddress: null, 
        trackings: [],
        currentTracking: null,
        currentTrackingIndex: null,
        shippingMethod: null,
        freightPayment: null
      }
    },
    methods: {
      openTracking(tracking, index) {
        this.currentTracking = tracking;
        this.currentTrackingIndex = index;
        this.modals.newTracking = true;
      },
      removeTracking(index) {
        this.trackings.splice(index, 1);
      },
      onAddTracking(json) {
        this.trackings.push(json);
      },  
      onEditTracking(json, index) {
        this.trackings[index] = json;
        this.currentTracking = null;
        this.currentTrackingIndex = null;
      },
      onCloseTracking() {
        this.modals.newTracking = false
        this.currentTracking = null;
        this.currentTrackingIndex = null;
      },
      removeLine(index){
        this.docLines.splice(index, 1);
        this.calculateTotals();
      },
      onCancelItemsForm(){
        this.selOpenDelivery = null;
        this.selOpenItem = null;
        this.showItemsForm = false;
        this.openItems = null;
      },
      addLines(){
        this.docLines = this.docLines.concat(this.selOpenItem);
        this.calculateTotals();
        this.selOpenDelivery = null;
        this.selOpenItem = null;
        this.openItems = null;

      },
      onSelectOpenDelivery(data){
        this.openItems = null;
        this.selOpenItem = null;

        axios.all([
          axios.get(`/api/deliveries/getDelivery?DocNum=${data.DocNum}`),
          axios.get(`/api/deliveries/document_lines?DocNum=${data.DocNum}`),
        ])
        .then(axios.spread((delivery, dLines) => {
          const deliveryLines = delivery.data.value[0].DocumentLines;

          const batchRequests = deliveryLines.map(x => {
            return axios.get(`${this.HANA_URL}/api/item/pedimentos_by_item?DeliveryDocNum=${data.DocNum}&ItemCode=${x.ItemCode}`)
          });
          axios.all(batchRequests)
            .then(axios.spread((...responses) => {
              let batchOptions = responses.map((res, index) => {
                return {
                  ItemCode: deliveryLines[index].ItemCode,
                  BatchNums: res.data
                    .map(x => x.BatchNum)
                    .filter(x => !x.toLowerCase().includes("nacional"))
                }
              })
              .filter(x => x.BatchNums.length > 0)

              batchOptions.forEach(x => {
                let item = dLines.data.value.find(y => y['DeliveryNotes/DocumentLines'].ItemCode === x.ItemCode && y.Items.U_Import === 'Y');
                if (item) {
                  item.BatchNum = x.BatchNums[0];
                  item.BatchNums = x.BatchNums;
                }
              });

          dLines.data.value
          .filter(x => {
            const line = deliveryLines.find(y => y.ItemCode === x['DeliveryNotes/DocumentLines'].ItemCode);
            const status = line.LineStatus;
            return status !== "bost_Close";
          })
          .forEach(dl => {
            const line = deliveryLines.find(x => x.ItemCode === dl['DeliveryNotes/DocumentLines'].ItemCode)
            const baseLine = deliveryLines.find(x => x.ItemCode === dl['DeliveryNotes/DocumentLines'].ItemCode).BaseLine;
            const status = line.LineStatus;
            const remainingOpenQuantity = line.RemainingOpenQuantity;
            dl.ItemCode = dl['DeliveryNotes/DocumentLines'].ItemCode;
            dl.baseLine = baseLine;
            dl.checked = true;
            dl.disabled = status === "bost_Close";
            dl.remainingOpenQuantity = remainingOpenQuantity;
            if(remainingOpenQuantity !== dl['DeliveryNotes/DocumentLines'].Quantity){
              dl.newQuantity = remainingOpenQuantity;
            } else {
              dl.newQuantity = dl['DeliveryNotes/DocumentLines'].Quantity;
            }
            dl.addedLine = true;
            dl.docEntry = data.DocEntry;
          })

          this.openItems = [
            {
              all: 'Seleccionar Todos',
              items: dLines.data.value
                .sort((a, b) => a['DeliveryNotes/DocumentLines'].LineNum - b['DeliveryNotes/DocumentLines'].LineNum)
            }
          ];

          this.calculateTotals();
          }))
        }))
        .catch(errors => {
          console.error(errors);
        });
      },
      loadItemsForm(){
        this.showItemsForm = true;
        const deliveriesJson = {
          select: `"DocNum",  "DocEntry"`,
          table: "ODLN",
          where: `WHERE
            CANCELED != 'Y' AND
            "DocStatus" = 'O' AND
            "CardCode" = '${this.delivery.CardCode}' AND
            "DocCur" = '${this.delivery.DocCurrency}' AND
            "ShipToCode" = '${this.delivery.ShipToCode}' AND
            "DocNum" != ${this.delivery.DocNum}
          ORDER BY "DocNum" DESC`,
        };
        axios
          .post(`${this.HANA_URL}/api/hana/basic_general_query`, deliveriesJson)
          .then((res) => {
            this.openDeliveries = res.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
      assignPayMethod(data){
        if([8, 25].includes(this.delivery.PaymentGroupCode)){ // 8: Contado, 25: DCP
          const found = this.paymentMethods.find(x => x.value === data.U_TS_PmntMethod);
          if(found){
            this.selPaymentMethod = found;
          }
        }
      },
      calculateTotals(){
        let subtotal = 0;
        this.docLines.forEach((item) => {
          if(item.checked && !item.disabled){
            subtotal += this.calculateLineTotal(item);
          }
        });
        this.subtotal = subtotal || 0;
        this.iva = this.customer.FederalTaxID !== 'XEXX010101000' ? (this.subtotal * 0.16) || 0 : 0;
        this.total = this.subtotal + this.iva;
        if(this.delivery.DiscountPercent > 0){
          let descuento_subtotal = parseFloat((this.subtotal * this.delivery.DiscountPercent/100).toFixed(2))
          let descuento_iva = parseFloat((this.iva * this.delivery.DiscountPercent/100).toFixed(2))
          this.discount = descuento_iva + descuento_subtotal;
          this.total = this.total - this.discount
        }
      },
      calculateLineTotal(row){
        const quantity = parseFloat(row.newQuantity);
        const unitPrice = parseFloat(row['DeliveryNotes/DocumentLines'].UnitPrice);
        return (quantity * unitPrice) || 0;
      },
      customFraccLabel({Name, U_TS_Descrip}){
        return `${Name} - ${U_TS_Descrip}`
      },
      deliveryPdf(){
        this.downloadingDelivery = true;
        const json = {
          "DocCode": "DLN20013",
          "Pairs": {
            "DocKey@": this.delivery.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            let link = document.createElement('a');
            link.download = `Entrega_${this.delivery.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();
          }
        }).catch(error => {
          console.error(error); 
        }).finally(() => {
          this.downloadingDelivery = false;
        });
      },
      dcpPdf(){
        this.downloadingDcp = true;
        const json = {
          "DocCode": "DLN20009",
          "Pairs": {
            "DocKey@": this.delivery.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            let link = document.createElement('a');
            link.download = `DCP_${this.delivery.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();
          }
        }).catch(error => {
          console.error(error); 
        }).finally(() => {
          this.downloadingDcp = false;
        });
      },
      formatDate(date){
        return moment(date).format('YYYY-MM-DD');
      },
      askBefore(){
        const optionsAvailable = this.facturasAnticipo && this.facturasAnticipo.length > 0;
        const notSelected = !this.facturaAnticipoSelected;

        if(optionsAvailable && notSelected){
          this.$swal({
            title: "Tienes factura(s) de anticipo sin relacionar",
            text: "¿Estás seguro de que es correcto y deseas facturar?",
            icon: "warning",
            confirmButtonText: "Si, facturar",
            cancelButtonText: "No, regresar",
            showCancelButton: true,
          }).then((result) => {
            if(result.isConfirmed){
              this.createInvoice();
            }
          });
        } else {
          this.createInvoice();
        }
      },
      createInvoice(){
        this.creating = true;
        if(
          this.invoiceType === 'Comercio Exterior' && 
          this.docLines.some(item => 
            !item['DeliveryNotes/DocumentLines'].CantAd || 
            !item['DeliveryNotes/DocumentLines'].FraccionArancelaria || 
            !item['DeliveryNotes/DocumentLines'].UAduana
          )
        ){
          this.$swal("Error", "Favor de llenar todos los campos de Comercio Exterior", "error");
          this.creating = false;
          return;
        }
        else {
          let items = this.docLines
          .filter(x => x.checked && !x.disabled)
          .map((item) => {
            const dl = item['DeliveryNotes/DocumentLines'];
            let subTotal = (dl.UnitPrice * parseFloat(item.newQuantity));
            let rate = this.customer.FederalTaxID === 'XEXX010101000' ? 0 : 0.16
            let linea = {
              ProductCode: item.NCMCodesSetup.NCMCode,
              IdentificationNumber: dl.U_SubCode || dl.ItemCode, 
              Description: dl.U_SubDescription || dl.ItemDescription,
              UnitCode: dl.UoMCode,
              UnitPrice: dl.UnitPrice,
              Quantity: parseFloat(item.newQuantity),
              Subtotal: subTotal.toFixed(6),
              Unit: dl.MeasureUnit, //add this
              TaxObject: this.customer.FederalTaxID === 'XEXX010101000' ? "01" : "02",
              Total: (subTotal * (rate+1)).toFixed(6),
              // BaseLine: dl.LineNum,
            }
            if(this.invoiceType === 'Comercio Exterior'){
              const delDocLine = this.delivery.DocumentLines.find(x => x.ItemCode === dl.ItemCode);
              linea.ClaveFraccionArancelaria = dl.FraccionArancelaria.Name;
              linea.ValorUnitarioConcepto = (delDocLine.RowTotalFC/parseFloat(item.newQuantity)).toFixed(6);
              linea.CantidadAduana = dl.CantAd;
              linea.ImporteConcepto = delDocLine.RowTotalFC.toFixed(4);
              linea.ClaveUnidadAduana = dl.UAduana.Value;
            }
            if(this.customer.FederalTaxID !== 'XEXX010101000'){
              linea.Taxes=[
                {
                  "Total": (subTotal * rate).toFixed(6),
                  "Name": "IVA",
                  "Base": subTotal.toFixed(6),
                  "Rate": rate ,
                  "IsRetention": false
                }
              ]
            }
            if(item.BatchNum && item.Items.U_Import === 'Y' && this.invoiceType !== 'Comercio Exterior'){
              const digits = item.BatchNum.replace(/\s+/g, '');
              const regex = /^[0-9\s]*$/; // Solo números y espacios
              linea.NumerosPedimento = [item.BatchNum];
              if (digits.length === 15 && regex.test(digits)) {
                linea.NumerosPedimento = [digits.replace(/(\d{2})(\d{2})(\d{4})(\d{7})/, "$1  $2  $3  $4")];
              } else {
                this.creating = false;
                this.$swal("Error", `El número de pedimento "${item.BatchNum}" no cumple con los requerimientos`, "error");
                throw new Error("Error el número de pedimento no cumple con los requerimientos"); 

              }
            } else if(item.Items.U_Import === 'Y' && item.U_PedimentNum){
              const digits = item.U_PedimentNum.replace(/\s+/g, '');
              const regex = /^[0-9\s]*$/; // Solo números y espacios
              if (digits.length === 15 && regex.test(digits)) {
                linea.NumerosPedimento = [digits.replace(/(\d{2})(\d{2})(\d{4})(\d{7})/, "$1  $2  $3  $4")];
              } else {
                this.creating = false;
                this.$swal("Error", `El número de pedimento "${item.U_PedimentNum}" no cumple con los requerimientos`, "error");
                throw new Error("Error el número de pedimento no cumple con los requerimientos"); 

              }
            } else {
              // linea.NumerosPedimento = null
            }
            return linea;
          });

          const hasAddedLines = this.docLines.some(x => x.addedLine);
        
          this.facturama = {
            "CfdiType": "I",
            "PaymentForm": this.selPaymentMethod.value,
            "PaymentMethod": this.paymentMethod,
            //"ExpeditionPlace": ['XEXX010101000'].includes(this.customer.FederalTaxID) && this.invoiceType === 'Comercio Exterior' ? this.delivery.AddressExtension.BillToZipCode.slice(0, 5) : this.zipCode,
            "ExpeditionPlace": this.zipCode,
            "Date": moment().format('YYYY-MM-DDTHH:mm:ss'),
            "PaymentConditions": this.paymentGroup.PaymentTermsGroupName, 
            "Exportation": this.customer.FederalTaxID === 'XEXX010101000' && this.invoiceType === 'Comercio Exterior' ? "02" : "01",
            "Receiver": {
              "Rfc": this.customer.FederalTaxID,
              "CfdiUse": this.delivery.U_TS_UsoCFDI40,
              "Name": this.customer.CardName,
              "FiscalRegime": this.customer.U_TS_RegFiscal,
              "TaxZipCode": this.delivery.AddressExtension.BillToZipCode.slice(0, 5)
            },
            "Items": items,
            "GlobalInformation": this.globalInformation || null,
            "Observaciones": hasAddedLines ? null : this.delivery.Comments,
          }

          if(this.customer.FederalTaxID === 'XEXX010101000'){
            this.facturama.Receiver.TaxRegistrationNumber = this.customer.UnifiedFederalTaxID;
          }

          if(this.delivery.DocCurrency !== 'MXP'){
            let date = moment().format('YYYYMMDD');
            axios.get(`/api/getCurrencies?date=${date}`)
            .then(res => {
              if(res.data.error){
                this.$swal("Error", res.data.error.error.message.value, "error");
                this.creating = false;
                return;
              }
              else {
                this.facturama.CurrencyExchangeRate = res.data[this.delivery.DocCurrency];
                this.facturama.Currency=  this.delivery.DocCurrency;
                this.sap();
              }
            })
            .catch(err => {
              console.error(err); 
              this.creating = false;
            });
          } else {
            this.facturama.CurrencyExchangeRate = 1;
            this.facturama.Currency='MXN'
            this.sap();
          }
        }
      },
      sap() {
        let documentLines = this.docLines
        .filter(x => x.checked && !x.disabled)
        .map((item) => {
            const dl = item['DeliveryNotes/DocumentLines'];
            let pedimento;
            if (item.BatchNum && item.Items.U_Import === 'Y' && this.invoiceType !== 'Comercio Exterior') {
              const digits = item.BatchNum.replace(/\s+/g, '');
              const regex = /^[0-9\s]*$/; // Solo números y espacios
              if (digits.length === 15 && regex.test(digits)) {
                pedimento = digits.replace(/(\d{2})(\d{2})(\d{4})(\d{7})/, "$1  $2  $3  $4");
              } else {
                this.$swal("Error", `El número de pedimento ${item.BatchNum} no cumple con los requerimientos`, "error");
                this.creating = false;
                throw new Error("Error el numero de pedimento no cumple con los requerimientos");
              }
            } else if (item.Items.U_Import === 'Y' && item.U_PedimentNum) {
              const digits = item.U_PedimentNum.replace(/\s+/g, '');
              const regex = /^[0-9\s]*$/; // Solo números y espacios
              if (digits.length === 15 && regex.test(digits)) {
                pedimento = digits.replace(/(\d{2})(\d{2})(\d{4})(\d{7})/, "$1  $2  $3  $4");
              } else {
                this.$swal("Error", `El número de pedimento ${item.U_PedimentNum} no cumple con los requerimientos`, "error");
                this.creating = false;
                throw new Error("Error el numero de pedimento no cumple con los requerimientos");
              }
            } else {
              pedimento = null
            }
            let line =  {
              ItemCode: dl.ItemCode,
              Quantity: parseFloat(item.newQuantity),
              BaseType: 15,
              BaseEntry: item.docEntry || this.delivery.DocEntry,
              BaseLine: dl.LineNum,
              Price: dl.Price,
              U_SubCode: dl.U_SubCode,
              U_SubDescription: dl.U_SubDescription,
              U_PedimentNum: pedimento,
              Currency: this.delivery.DocCurrency,
            }

            if(this.invoiceType === 'Comercio Exterior'){
              const delDocLine = this.delivery.DocumentLines.find(x => x.ItemCode === dl.ItemCode);
              line.U_TS_FrArancelaria= dl.FraccionArancelaria.Name;
              line.U_TS_ValUnitDlls= (delDocLine.RowTotalFC/dl.CantAd).toFixed(6);
              line.U_TS_CantAd= dl.CantAd;
              line.U_TS_ValorDlls= (line.U_TS_CantAd * line.U_TS_ValUnitDlls).toFixed(4);
              line.U_TS_UAduana= dl.UAduana.Value;
            }
            return line
          });

        const hasAddedLines = this.docLines.some(x => x.addedLine);

        let sap = {
          "CardCode": this.delivery.CardCode,
          "DocCurrency": this.delivery.DocCurrency,
          "DocRate": this.facturama.CurrencyExchangeRate,
          "PaymentMethod": this.selPaymentMethod.value,
          "U_TS_ActStatus": "N",
          "U_TS_GenType": "N",
          "U_TS_DEQ": null,
          "BaseEntry": hasAddedLines ? null : this.delivery.DocEntry,
          "DocumentLines": documentLines,
          "U_WebUser": this.user.email,
          "U_Web": "Y",
          "ImportFileNum": this.importFileNum ? this.importFileNum.Folio : null, //Aplica solamente para el caso de que se requiera anotar una Referencia Saldo a Favor
          "U_AuthorizationKey": this.inputAuthKey || null, //En caso de que se necesite clave de autorización enviarla
          "U_TS_Incoterm": this.selIncoterm && this.invoiceType === 'Comercio Exterior' ? this.selIncoterm.Value : null,
          "U_WebTimbrado": this.stamp ? "Y" : "N",
          "U_FirstBuy": this.delivery.U_FirstBuy === 'Y' ? 'Y':'N',
        };

        if(this.facturaAnticipoSelected){
          this.facturama["cfdIsRelacionadosLista"] = [{ 
            "cfdIsRelacionados": this.facturaAnticipoSelected['U_WebUUID'] || this.facturaAnticipoSelected['UUID Tesselar'],
            "tipoRelacion": "07"
          }]
          sap.U_WebRefType = "07";
          sap.U_WebRefObj= "FA",
          sap.U_WebRefDocNum = this.facturaAnticipoSelected.Folio;
        }

        let emails = [];
        if(process.env.NODE_ENV === 'production'){
          emails = this.customer.ContactEmployees
          .filter((contacto) => contacto.U_TS_EnvioCorreo === "SI" && contacto.E_Mail)
          .map((contacto) => contacto.E_Mail);
        } else {
          emails = [this.user.email];
        }

        let body = {
          facturoporti: this.facturama,
          sap,
          emails,
          type: this.customer.FederalTaxID === 'XEXX010101000' ? this.invoiceType.code : "normal",
          timbrado: this.stamp,
        };
        

        if(this.customer.FederalTaxID === 'XEXX010101000' && this.invoiceType === 'Comercio Exterior'){
          body.extras = {
            "Incoterm": this.selIncoterm.Value,
            "AddressExtension": this.delivery.AddressExtension,
            //"warehouse": this.delivery.DocumentLines[0].WarehouseCode,
          };
          body.type='comercio_exterior'
        }
        else if(this.customer.FederalTaxID === 'HDM001017AS1'){
          body.type = 'addenda'
        }else{
          body.type='normal'
        }

        if(this.delivery.DiscountPercent > 0){
          body.discount = this.discount
          body.discount_percent = this.delivery.DiscountPercent/100
        }

        let endpointType = this.customer.FederalTaxID === 'XEXX010101000' && this.invoiceType === 'Comercio Exterior' ? 'comercioExterior' : 'invoice';
        console.log("JSON to INVOICE", body)
        
        axios.post(`api/fpt/${endpointType}`, body)
        .then(res => {
          console.log("🟦 INVOICE RESPONSE", res);
          if(res.data.DocNum){
            const invoiceNum = res.data.DocNum;
            const docEntry = res.data.DocEntry;
            const baseMsg = `La factura #${invoiceNum} ha sido creada`;
            if (body.sap.ImportFileNum) {
              this.reconciliando = true;
              axios.post(`api/fpt/reconciliation?DocEntry=${docEntry}`)
                .then(rec_res => {
                  console.log("🟦 RECONCILIATION RESPONSE", rec_res)
                  const msg = rec_res.data.msg === 'Factura reconciliada'
                    ? ' y reconciliada.'
                    : '.';
                  this.showSuccessMessage(baseMsg, msg, invoiceNum);
                })
                .catch(() => {
                  this.showSuccessMessage(baseMsg, '.', invoiceNum);
                });
            } else {
              this.showSuccessMessage(baseMsg,'',invoiceNum);
            }
          } else {
            this.creating = false;
            if(process.env.NODE_ENV === 'production'){
              posthog.capture('InvoiceError', res);
            }
            if(res.data.error){
              if(res.data.error.error){
                this.$swal("Error", res.data.error.error.message.value, "error")
              } else if(res.data.error.Message){
                this.$swal("Error", res.data.error.Message, "error")
              } else {
                this.$swal('Error', "Algo salió mal, por favor antes de reintentar verifica si fue creado correctamente y da aviso a soporte", 'error');
                console.error("Error", res);
                this.load();
              }
            } else if(res.data.msg){
              this.$swal("Error", res.data.msg, "error");
              this.load();
            } else {
              this.$swal('Error', "Algo salió mal, por favor antes de reintentar verifica si fue creado correctamente y da aviso a soporte", 'error');
              console.error("Error", res);
              this.load();
            }
          } 
        }).catch(err => {
          this.creating = false;
          console.error(err);
          this.$swal('Error', "Algo salió mal, por favor antes de reintentar verifica si fue creado correctamente y da aviso a soporte", 'error');
          if(process.env.NODE_ENV === 'production'){
            posthog.capture('InvoiceError', err);
          }
        });
      },
      showSuccessMessage(baseMsg, msg, invoiceNum){
        this.reconciliando = false;
        if(this.trackings && this.trackings.length > 0){
          this.generateTracking(invoiceNum, baseMsg, msg);
        } else {
          this.creating = false;
          this.$swal("Factura creada", `${baseMsg}${msg}`, "success")
            .then(() => {
              this.$router.push(`/invoice/${invoiceNum}`);
            });
        }
      },
      generateTracking(invoiceNum, baseMsg, msg){
        const requests = this.trackings.map((json, index) => {
          console.log("generateTracking", index, json);

          const delUser = this.delivery.U_FulfillmentDeliveryUser;
          const ref = `FA ${invoiceNum}${delUser ? ` validado por ${delUser}` : ``}`

          if(json.origin){ // Envia
            json.origin.reference = ref;
            return axios.post(`api/envia/label/create`, json);
          } 
          else { // Paquetexpress
            json.invoiceReference = ref;
            console.log("Paquetexpress JSON", json);
            return axios.post(`api/paquetexpress/label`, json);
          }
        });

        axios.all(requests)
          .then(axios.spread((...responses) => {
            console.log("🟦 TRACKING RESPONSES", responses);
              this.saveTracking(responses, invoiceNum, baseMsg, msg);
          }))
          .catch((e) => {
            this.creating = false;
            console.error(e);
            this.$swal("Factura Creada", `No se pudo generar la guía. ${baseMsg}${msg}`, "error")
              .then(() => {
                this.$router.push(`/invoice/${invoiceNum}`);
              });

          });
      },
      saveTracking(responses, invoiceNum, baseMsg, msg){
        const requests = [];
        const errors = [];

        responses.forEach((res, index) => {
          this.trackings[index].packages.forEach((pkg, indexPkg) => {
            console.log("TRACKING", pkg, index);

          if(
            res.data.meta && res.data.meta === "generate" // Envia
            || res.data.carrier // Paquetexpress
          ){

            let t, guia, trackingId, cost, folio;

            if(res.data.meta && res.data.meta === "generate"){ //Envia
              t = res.data.data[0];
              guia = t.shipmentId;
              trackingId = t.trackingNumber;
              cost = t.totalPrice;
              folio = t.folio;
            } else if(res.data.carrier) { // Paquetexpress
              t = res.data;
              guia = t.guia;
              trackingId = t.rastreo;
              cost = t.cost;
              folio = null;
            }

            const json = {
              Name: `${guia}-${indexPkg}`,
              Code: `${guia}-${indexPkg}`,
              U_DocNum: invoiceNum,
              U_DocType: 'invoice',
              U_Carrier: t.carrier,
              U_Service: t.service,
              U_CreatedAt: moment().toISOString(),
              U_E_ShipmentId: guia,
              U_E_Folio: folio,
              U_TrackingId: trackingId,
              U_Cost: cost,
              U_TrackingStatus: "Pendiente de recolección",
              U_LabelLink: t.label,
              U_Weight: pkg.weight,
              U_Length: pkg.dimensions.length,
              U_Width: pkg.dimensions.width,
              U_Height: pkg.dimensions.height,
              U_LastEventDesc: "Pendiente de Recolección",
              U_LastEventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
              U_EstimatedDeliveryDate: null,
              U_Comments: null,
              U_FromCedis: this.whseAddress.WarehouseCode.substring(0, 3)
            };
            console.log("🟦 JSON SAP", index, json);
            requests.push( axios.post(`api/trkd/envioclick`, json) );
          } 
          else {
            console.error("Error", index, res.data)
            if (res.data.error && res.data.error.message) {
              errors.push(res.data.error.description + ' ', res.data.error.message);
            } else if(res.data.data && res.data.data.messages){
              errors.push(res.data.data.messages.map(x => x.description).join(', '));
            } else if(res.data.axios_request_err) {
              errors.push(res.data.axios_request_err);
            } else {
              errors.push(`No se pudo guardar la guía ${index}`);              
            }
          }
          });
        });

        if(requests.length === 0){
          this.$swal("Factura creada", `${errors.join(', ')} ${baseMsg} ${msg}`, "error")
            .then(() => {
              this.$router.push(`/invoice/${invoiceNum}`);
            });
          this.creating = false;
          return;
        }

        axios.all(requests)
          .then(axios.spread((...responses) => {
            console.log("🟦 SAP RESPONSES", responses.map(x => x.data));
            if(responses.every(x => x.data.Code) && !errors.length){
              this.$swal("Factura y guía(s) creadas", `${baseMsg} ${msg}`, "success")
              .then(() => {
                this.$router.push(`/invoice/${invoiceNum}`);
              });
            } else {
              console.error("Error in SAP responses", responses);
              const sapErrors = responses
                .filter(x => !x.data.Code)
                .map(x => {
                  if(x.data.error && typeof x.data.error === 'string'){
                    return x.data.error;
                  } else if(x.data.error && x.data.error.message){
                    return x.data.error.message.value;
                  } else {
                    return 'Error al guardar guía en sap';
                  }
                });
              errors.push(...sapErrors);
              this.$swal("Factura creada", `${errors.join(', ')} ${baseMsg} ${msg}`, "error")
              .then(() => {
                this.$router.push(`/invoice/${invoiceNum}`);
              });
            }
          }))
          .catch((e) => {
            console.error(e);
            this.$swal("Error", `Hubo un problema al guardar la guía ${errors.join(', ')} ${baseMsg} ${msg}`, "error")
              .then(() => {
                this.$router.push(`/invoice/${invoiceNum}`);
              });
          })
          .finally(() => {
            this.creating = false;
          });
      },
      load(){
      axios.get(`/api/deliveries/getDelivery?DocNum=${this.$route.params.DocNum}`)
      .then(res => {
        this.delivery = res.data.value[0];
        // console.log(md5(moment().format("YYYY-MM-DD") + this.delivery.CardCode).toUpperCase())
        console.log("DELIVERY", this.delivery);
        this.currency = currency.find(x => x.key === this.delivery.DocCurrency);
        this.selPaymentMethod = this.paymentMethods.find(x => x.value === this.delivery.PaymentMethod);

        if(this.delivery.DocumentStatus === 'bost_Open'){
          let query = {
            select: "*",
            table: "@USTI",
            where: `WHERE "U_Email" = '${this.user.email}'`
          };
          
          axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, query)
          .then(res => {
            if(res.data && res.data.length){
              const deliveryWhse = this.delivery.DocumentLines[0].WarehouseCode;
              if(
                ["FA","FA_NC"].includes(res.data[0].U_DocumentType) && 
                res.data[0].U_Warehouse && 
                res.data[0].U_Warehouse.split(",").includes(deliveryWhse)
              ){
                this.invoicingPermission = true;
              }
            }
          }).catch(err => {
            console.error(err); 
          });
        }

        axios.get(`/api/paymentsByCode?code=${this.delivery.PaymentGroupCode}`)
        .then(res => {
          this.paymentGroup = res.data.value.find(x => x.GroupNumber === this.delivery.PaymentGroupCode);
        }).catch(err => {
          console.error(err); 
        });
        
        axios.get(`/api/warehouses/${this.delivery.DocumentLines[0].WarehouseCode}`)
        .then(res => {
          this.whseAddress = {
            "WarehouseCode": res.data.value[0].WarehouseCode,
            "Street": res.data.value[0].Street,
            "StreetNo": res.data.value[0].StreetNo,
            "ZipCode": res.data.value[0].ZipCode,
            "Block": res.data.value[0].Block,
            "BuildingFloorRoom": res.data.value[0].BuildingFloorRoom,
            "City": res.data.value[0].City,
            "Country": res.data.value[0].Country,
            "State": res.data.value[0].State,
          };
          this.zipCode = res.data.value[0].ZipCode
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`api/user_fields/ShippingMethod`)
        .then(res => {
          this.shippingMethod = res.data.value[0].ValidValuesMD.find(x => x.Value === this.delivery.U_ShippingMethod);
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`api/user_fields/FreightPayment`)
        .then(res => {
          this.freightPayment = res.data.value[0].ValidValuesMD.find(x => x.Value === this.delivery.U_FreightPayment);
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`/api/business_partners?card_code=${this.delivery.CardCode}`)
        .then(res => {
          this.customer = res.data;
          // console.log("CUSTOMER", this.customer)

          if(this.delivery.CardCode === 'C02858'){
            this.stamp = false;
            this.stampDisabled = true;
          } /* else if(this.delivery.NumAtCard !== 'MuestraCPM' ){
            this.stamp = false;
            this.stampDisabled = this.delivery.CardCode === 'C02800';
          } */ else {
            this.stamp = true;
            this.stampDisabled = false;
          }

          if(this.customer.FederalTaxID === "XAXX010101000"){

            this.globalInformation = {
              periodicity: "01",
              months: moment().format('MM'),
              year: moment().format('YYYY')
            }
          }

          let anticipo_query = {
              "select": "*",
              "table": "Comparison_Anticipo_vs_Original",
              "where": `WHERE "CardCode" = '${this.customer.CardCode}' AND "FA Relacionada" = 'No relacionada' AND ("UUID Tesselar" IS NOT NULL OR "U_WebUUID" IS NOT NULL) AND "DocCur" = '${this.delivery.DocCurrency}'`
          };

          axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, anticipo_query)
          .then(res => {
            this.facturasAnticipo = res.data;
          }).catch(err => {
            console.error(err); 
          });

          if(
            this.customer.Properties21 === 'tYES' ||
            ([8,23,25].includes(this.delivery.PaymentGroupCode) && 
            (this.delivery.NumAtCard === null || !this.delivery.NumAtCard.includes('MuestraCPM')))
          ){
              // this.needsAuthorization = true;

              let jsonBalance = {
                  "select": "*",
                  "table": "Insufficient_Balance_Favor",
                  "where": `WHERE "CardCode" = '${this.customer.CardCode}'`
              };

              axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, jsonBalance)
              .then(res => {
                let cobros = res.data.find((element) => element.Type === "RC");
                let notasCredito = res.data.find((element) => element.Type === "NC");
                let facturas = res.data.find((element) => element.Type === "FA");

                let saldo = ((cobros ? cobros["Saldo a Cuenta"] : 0) + (notasCredito ? notasCredito["Saldo a Cuenta"] : 0)) - 
                (facturas ? facturas["Saldo a Cuenta"] : 0);
                let excedente = saldo - this.delivery.DocTotal

                // this.claveAutorizacion = md5(moment().format("YYYY-MM-DD") + this.delivery.CardCode).toUpperCase();
                // console.log("CLAVE DE AUTORIZACION",this.claveAutorizacion)

                if(saldo < this.delivery.DocTotal){
                  this.insufficientBalanceText = `Saldo a favor del cliente insuficiente, Excede por: ${this.currencyFormat(excedente)}`;
                }
                  if(([8,23,25].includes(this.delivery.PaymentGroupCode) && (this.delivery.NumAtCard === null || !this.delivery.NumAtCard.includes('MuestraCPM')))){   	// Si el PaymentGroupCode con el valor 8, 23 o 25 y el campo NumAtCard no contiene el texto: “MuestraCPM” continuar con el siguiente paso
                    this.needsReference = true;

                    let jsonBalanceFavor = {
                        "select":`T0."Folio", T0."Tipo", T0."Fecha", T0."Saldo a Favor", T0."CardCode", T1."U_TS_PmntMethod", "DocCurr"`,
                        "table":"Balance_Favor_Customer_Search",
                        "where": `T0 
                        LEFT JOIN "ORCT" T1 ON T0."Folio" = T1."DocNum"
                        WHERE T0."CardCode" = '${this.customer.CardCode}'
                        `
                    };
                    axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, jsonBalanceFavor)
                    .then(res => {
                      this.balanceFavorOptions = res.data;
                    }).catch(err => {
                      console.error(err); 
                    });
                  } else { 	// Si no, permitir crear la factura
                    this.needsReference = false;
                  }
              }).catch(err => {
                console.error(err); 
              })
              
          } else { 
            // this.needsAuthorization = false;
          }

          axios.all([
            axios.get(`/api/deliveries/document_lines?DocNum=${this.$route.params.DocNum}`),
          ])
            .then(axios.spread((dLines) => {
  
              const batchRequests = this.delivery.DocumentLines.map(x => {
                return axios.get(`${this.HANA_URL}/api/item/pedimentos_by_item?DeliveryDocNum=${this.delivery.DocNum}&ItemCode=${x.ItemCode}`)
              });
  
              axios.all(batchRequests)
                .then(axios.spread((...responses) => {
  
                  let batchOptions = responses.map((res, index) => {
                    return {
                      ItemCode: this.delivery.DocumentLines[index].ItemCode,
                      BatchNums: res.data
                        .map(x => x.BatchNum)
                        .filter(x => !x.toLowerCase().includes("nacional"))
                    }
                  })
                  .filter(x => x.BatchNums.length > 0)
  
                  batchOptions.forEach(x => {
                    let item = dLines.data.value.find(y => y['DeliveryNotes/DocumentLines'].ItemCode === x.ItemCode && y.Items.U_Import === 'Y');
                    if (item) {
                      item.BatchNum = x.BatchNums[0];
                      item.BatchNums = x.BatchNums;
                    }
                  });
  
                  dLines.data.value.forEach(dl => {
                    const dLine = dl['DeliveryNotes/DocumentLines'];
                    const status = this.delivery.DocumentLines.find(x => x.ItemCode === dLine.ItemCode).LineStatus;
                    const remainingOpenQuantity = this.delivery.DocumentLines.find(x => x.ItemCode === dLine.ItemCode).RemainingOpenQuantity;
                    const baseLine = this.delivery.DocumentLines.find(x => x.ItemCode === dLine.ItemCode).BaseEntry;
                    dl.baseLine = baseLine;
                    dl.checked = true;
                    dl.disabled = status === "bost_Close";
                    dl.remainingOpenQuantity = remainingOpenQuantity;
                    if (remainingOpenQuantity !== dLine.Quantity) {
                      dl.newQuantity = remainingOpenQuantity;
                    } else {
                      dl.newQuantity = dLine.Quantity;
                    }
                  })
                  this.docLines = dLines.data.value
                    .sort((a, b) => a['DeliveryNotes/DocumentLines'].LineNum - b['DeliveryNotes/DocumentLines'].LineNum);
                  this.calculateTotals();
  
                  // console.log("DOCUMENT LINES", this.docLines);
  
                }))
                .catch(error => {
                  console.error(error);
                });
            })).catch(error => {
              console.error(error);
            });
        }).catch(err => {
          console.error(err); 
        });

      }).catch(err => {
        console.error(err); 
      })
      },
      preventExit(event) {
        if(this.creating || this.reconciliando){
          event.preventDefault();
          event.returnValue = "Facturación en proceso. ¿Estás seguro que deseas salir de la página?";
          const exitProcess = {
            DocNum: this.delivery.DocNum,
            DocEntry: this.delivery.DocEntry,
            DocType: "Delivery",
            Email: this.user.email,
            ExitType: "LeavePage"
          }
          posthog.capture('ExitProcess', exitProcess);
        }
      },
    },
    created(){
      this.user = getAuth().currentUser;
      this.load();

      axios.get(`/api/regimen_fiscal`)
      .then(res => { 
        this.regimenes = res.data;
      }).catch(err => {
        console.error(err); 
      });

      axios.get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
      }).catch((error) => {
        console.error(error);
      });

      axios.get(`api/user_fields/TS_Incoterm`)
      .then(res => {
        this.incoterms = res.data.value[0].ValidValuesMD;
      }).catch(err => {
        console.error(err); 
      });

      axios.get(`api/user_fields/TS_UAduana`)
      .then(res => {
        this.UAduanaOptions = res.data.value[0].ValidValuesMD;
      }).catch(err => {
        console.error(err); 
      });

      axios.get(`api/items/tariff_fractions`)
      .then(res => {
        this.fraccArancelarias = res.data;
      }).catch(err => {
        console.error(err); 
      });
    },
    computed:{
      paymentMethod(){
        if (!this.selPaymentMethod) return null;
        return this.selPaymentMethod.value === '99' ? 'PPD' : 'PUE';
      },
      validation() {
        const { selPaymentMethod, needsReference, importFileNum, docLines, customer, invoiceType, selIncoterm, total, facturaAnticipoSelected} = this;

        const complete = {
          "No tienes permiso para facturar esta entrega": this.invoicingPermission,
          "Vía de Pago": selPaymentMethod,
          // "Clave de Autorización": !(needsAuthorization && (inputAuthKey && inputAuthKey !== claveAutorizacion)),
          "Referencia Saldo a Favor o Factura Anticipo": !needsReference || importFileNum || facturaAnticipoSelected,
          "Pedimentos": !docLines.some(x => x.Items.U_Import === 'Y' && !x.U_PedimentNum && !x.BatchNum),
          "Tipo de Factura": customer.FederalTaxID !== 'XEXX010101000' || invoiceType,
          "Incoterm": customer.FederalTaxID !== 'XEXX010101000' || selIncoterm || invoiceType !== 'Comercio Exterior',
          "Cantidad en Artículos": docLines
            .filter(x => !x.disabled)
            .every(x => x.newQuantity > 0 && x.newQuantity <= x.remainingOpenQuantity),
          "Total en Artículos": total > 0,
          "C. P. de Almacén": this.zipCode,
          "Condiciones de Pago": this.paymentGroup,
        };
        return {
          valid: Object.values(complete).every((x) => x),
          missing: Object.keys(complete).filter((x) => !complete[x]),
        };
      },
      popoverData() {
        if (this.validation.missing.length > 0) {
          return {
            title: "<small><b>Verifica los siguientes campos:</b></small>",
            content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
            placement: "righttop",
          };
        } else {
          return null;
        }
      },
    },
    mounted(){
      window.addEventListener('beforeunload', this.preventExit);
    },
    beforeDestroy(){
      window.removeEventListener('beforeunload', this.preventExit);
    },
    beforeRouteLeave(to, from, next){
      if(this.creating || this.reconciliando){
        this.$swal({
          title: "Facturación en proceso",
          text: "¿Estás seguro que deseas salir de la página? Si sales, podrías afectar el timbrado de la factura.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Salir de todos modos",
          cancelButtonText: "Permanecer en la página",
        })
        .then((result) => {
          if (result.isConfirmed) {
            const exitProcess = {
              DocNum: this.delivery.DocNum,
              DocEntry: this.delivery.DocEntry,
              DocType: "Delivery",
              Email: this.user.email,
              ExitType: "ChangeRoute"
            }
            posthog.capture('ExitProcess', exitProcess);
            next();
          }
        });
      } else {
        next();
      }
    }
  }
</script>

<style scoped>
.custom-side-cards{
  min-width: 100%; 
  width: 100%;
}
@media (min-width:1200px) { 
  .custom-side-cards {
    min-width: 360px; 
    width: 360px;  
  }
}
.custom-table{
  th, td {
    padding: 12px 12px;
    
  }
  td{
    vertical-align: middle;
  }
  td:first-child, 
  th:first-child {
    padding-left: 24px; /* Ajusta el padding que quieras */
  }

  td:last-child, 
  th:last-child {
    padding-right: 24px; /* Ajusta el padding que quieras */
  }
}

.remove-button {
  background-color: white;
  height: 20px;
  width: 20px;
  border-radius: 0.375rem;
  color: #f5365c;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.remove-button:hover {
  background-color: #fee2e2;
}
</style>

<style>
.modal-custom-size {
  max-width: 1100px;
}
</style>